<template>
  <button
    class="btn-code"
    :class="{'btn-disabled':countDown>-1}"
    :disabled="countDown>-1"
    @click.prevent="doSend"
  >{{textContent}}</button>
</template>

<script>
export default {
  props: {
    sessionName: {
      type: String,
      required: true
    },
    actionPath: {
      type: String,
      required: true
    },
    actionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // whether code not sent / out of valid time
      countDown: -1
    };
  },
  computed: {
    textContent: function() {
      if (this.countDown < 0) {
        return "获取验证码";
      } else {
        return this.countDown + "s 后重新获取";
      }
    }
  },
  methods: {
    doSend() {
      this.requestCode();
    },
    // request sercurity code by mail
    requestCode() {
      this.$http
        .post(this.actionPath, this.actionData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.$emit("send", new Date().getTime() + 60 * 10 * 1000);
            this.doCountDown();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log("ERROR", err);
        });
    },
    doCountDown() {
      let endTime = Number.parseInt((new Date().getTime() + 60000) / 1000);
      sessionStorage.setItem(this.sessionName, endTime);
      this.doCheck(endTime);
    },
    // check session whether code is ready to be requested
    // t: expire time
    doCheck(t) {
      // get expire time from session
      let endTime = t ? t : sessionStorage.getItem(this.sessionName);
      if (!endTime) {
        this.countDown = -1;
        return;
      }
      let nowTime = Number.parseInt(new Date().getTime() / 1000);
      let gapTime = endTime - nowTime;
      if (gapTime < 1 || gapTime > 60) {
        sessionStorage.removeItem(this.sessionName);
        this.countDown = -1;
        return;
      }

      let timer = null;
      this.countDown = gapTime;
      timer = setInterval(() => {
        nowTime = Number.parseInt(new Date().getTime() / 1000);
        let gapTime = endTime - nowTime;
        if (gapTime < 1) {
          clearInterval(timer);
          sessionStorage.removeItem(this.sessionName);
          this.countDown = -1;
        } else {
          this.countDown = gapTime;
        }
      }, 1000);
    }
  },
  mounted: function() {
    this.doCheck();
  }
};
</script>

<style lang="scss" scoped>
.btn-code {
  box-sizing: border-box;
  height: 20px;
  line-height: 20px;
  background-color: transparent;
  padding: 0;
  border: none;
  font-size: 14px;
  color: #2f3035;
  box-sizing: border-box;
  cursor: default;
  opacity: 0.8;
  transition: opacity 0.2s, color 0.2s;
  &:hover {
    opacity: 1;
  }
  &.btn-disabled {
    color: #999;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vCode.vue